<template>
<div class="contentBox liveSharePage">
    <div class="pageTitle">
        <!--<h1>频道分享</h1>-->
        <el-steps :active="2" simple finish-status="wait" style="padding-left: 0">
            <el-step title="编辑" icon="el-icon-edit" @click.native="jumpNavPage('/live/edit')"></el-step>
            <el-step title="发起直播" icon="el-icon-video-play" @click.native="jumpNavPage('/live/launch')"></el-step>
            <el-step title="分享" icon="el-icon-share"></el-step>
            <el-step title="监控统计" icon="el-icon-data-analysis" @click.native="jumpNavPage('/live/statistics')"></el-step>
            <el-step title="录播" icon="el-icon-video-camera" @click.native="jumpNavPage('/live/history')"></el-step>
        </el-steps>
    </div>
    <div class="advanceds">
        <div class="title">
            <span>页面分享</span>
        </div>
        <div class="advancedInfo">
            <div class="infoItem">
                <span class="label">网页地址</span>
                <el-input placeholder="请输入内容" class="w600" v-model="shareInfo.pageUri">
                    <el-button slot="append" type="primary" v-clipboard:copy="shareInfo.pageUri" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</el-button>
                </el-input>
            </div>
            <div class="infoItem">
                <span class="label">二维码</span>
                <div class="qrcodeBox">
                    <img :src="shareInfo.qrData" alt />
                </div>
            </div>
        </div>
    </div>
    <div class="advanceds">
        <div class="title">
            <span>直播流</span>
        </div>
        <div class="tipsBox">
            <img src="../../assets/tipsIcon.svg" alt="" />
            直播流地址可用于嵌入自己的网站或APP播放直播，或用于其他直播平台拉流。因播放地址含有效期鉴权，请先输入地址有效天数，然后点击【生成播放地址】按钮。
        </div>
        <div class="advancedInfo">
            <div class="infoItem">
                <span class="label">有效小时</span>
                <el-input-number v-model="hours" controls-position="right" :min="1" :max="1024" @change="genStreamAddress">
                </el-input-number>
                <!--<el-input placeholder="请输入内容" :style="{ width: '287px' }" v-model="hours">
                    <el-button slot="append" @click="genStreamAddress">生成</el-button>
                </el-input>-->
            </div>
            <div class="infoItem">
                <span class="label">RTMP地址</span>
                <el-input placeholder="请输入内容" class="w600" :value="stream.rtmpURI">
                    <el-button slot="append" type="primary" v-clipboard:copy="stream.rtmpURI" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</el-button>
                </el-input>
            </div>
            <div class="infoItem">
                <span class="label">m3u8地址</span>
                <el-input placeholder="请输入内容" class="w600" :value="stream.hlsURI">
                    <el-button slot="append" type="primary" v-clipboard:copy="stream.hlsURI" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</el-button>
                </el-input>
            </div>
            <div class="infoItem">
                <span class="label">flv地址</span>
                <el-input placeholder="请输入内容" class="w600" :value="stream.flvURI">
                    <el-button slot="append" type="primary" v-clipboard:copy="stream.flvURI" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</el-button>
                </el-input>
            </div>
        </div>
    </div>
    <div class="advanceds">
        <div class="title">
            <span>高级</span>
        </div>
        <div class="tipsBox">
            <img src="../../assets/tipsIcon.svg" alt="" />
            在频道直播启动、直播停止和录播生成时，Quicklive可通知第三方平台。请在下面的输入框中输入回调地址。
        </div>
        <div class="advancedInfo">
            <div class="infoItem">
                <span class="label">回调地址</span>
                <el-input placeholder="请输入回调地址" class="w600" v-model="callback">
                    <el-button slot="append" type="primary" @click="saveCallback">保存</el-button>
                </el-input>
            </div>
        </div>
    </div>
</div>
</template>

<script>
    import common from '../../common.vue';
    const RESULT_MSG_MAPPER = {"0": '', '1':'登录已过期', '2': '无效的频道', '3': '访问被拒绝'};

    export default {
        name: "ChannelShare",
        data() {
            return {
                hours: '24',
                // 高级，消息回调地址
                callback: '',
                // 分享链接和二维码信息
                shareInfo: {},
                // 是否在请求地址
                loading: false,
                // 流播放地址
                stream: {}
            };
        },
        methods: {
            // 复制成功
            onCopy() {
                this.$message({
                    message: '复制成功！',
                    type: 'success'
                })
            },
            // 复制失败
            onError() {
                this.$message({
                    message: '复制失败！',
                    type: 'error'
                })
            },
            getShareInfo(cid){
                let _this = this;
                _this.$axios.post(common._BASE_ + 'channel/shareConfig',
                    this.$qs.stringify({channelId: cid})).then(function (res) {
                    let r = res.data;
                    if(r.code === 0){
                        r.share.qrData = 'data:image/png;base64,' + r.share.qrData;
                        _this.shareInfo = r.share;
                        _this.genStreamAddress();
                    }else{
                        _this.$message({
                            message: RESULT_MSG_MAPPER['' + Math.abs(r.code)],
                            type: 'error'
                        })
                    }
                });
            },
            genStreamAddress(){
                let _this = this;
                if(!_this.loading){
                    _this.loading = true;
                    _this.$axios.post(common._BASE_ + 'channel/getPlayUri',
                        this.$qs.stringify({channelId: _this.channelId, hours: _this.hours})).then(function (res) {
                            _this.loading = false;
                            let r = res.data;
                            if(r.code === 0){
                                _this.stream = r.stream;
                            }
                    });
                }
            },
            // 保存回调地址
            saveCallback(){
                let _this = this;
                _this.$axios.post(common._BASE_ + 'channel/saveCallback',
                    this.$qs.stringify({channelId: _this.channelId, callback: _this.callback})).then(function (res) {
                    let r = res.data;
                    if(r.code !== 0){
                        _this.$message({
                            message: RESULT_MSG_MAPPER['' + Math.abs(r.code)],
                            type: 'error'
                        })
                    }else{
                        _this.$notify({
                            title: '成功',
                            message: '回调地址保存成功',
                            type: 'success'
                        });
                    }
                });
            },

            jumpNavPage(path) {
                this.$router.push({
                    path: path,
                    params: { cid: this.channelId },
                    query: {cid: this.channelId}
                });
            }
        },
        mounted() {
            let cid = this.$route.params.cid || this.$route.query.cid;
            if (cid && parseInt(cid) > 0) {
                this.channelId = cid;
                this.getShareInfo(cid);
            }
        }
    };
</script> 

<style lang="less">
.liveSharePage {
    .advanceds {
        width: 1210px;
        background: #ffffff;
        border: 1px solid #e8e8e8;
        margin: 15px 0;

        .tipsBox {
            height: 44px;
            margin: 0 25px;
            display: flex;
            align-items: center;
            font-size: 12px;
            font-weight: 400;
            line-height: 26px;
            color: #7e868c;
            border-bottom: 1px dashed #e8e8e8;

            img {
                margin-right: 6px;
            }
        }

        .title {
            height: 44px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid #e9e9e9;
            padding: 0 21px;
            font-size: 16px;
            font-weight: bold;
            color: #221816;

            span::before {
                content: "";
                display: inline-block;
                width: 4px;
                height: 12px;
                background: #306ff6;
                border-radius: 3px;
                margin-right: 6px;
            }
        }

        .infoItem {
            display: flex;
            align-items: center;
            margin-bottom: 22px;
            margin-bottom: 17px;
        }

        .qrcodeBox {
            width: 138px;
            height: 138px;
            background: #ffffff;
            border: 1px solid #c1c5c5;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;

            img{
                width: 120px;
                height: auto;
            }
        }

        .w600 {
            width: 600px;
        }

        .label {
            width: 83px;
            font-size: 14px;
            font-weight: 400;
            line-height: 21px;
            color: #221816;
        }

        .advancedInfo {
            padding: 16px 32px;
            font-size: 14px;
            font-weight: 400;
            line-height: 21px;
            color: #221816;
        }

        .el-input-group__append {
            cursor: pointer;
        }
    }
}
</style>